import React, { useState, useRef, useEffect } from "react";
import "./SmartAddFAB.css";

export default function SmartAddFAB({ onSelect }) {
  const [open, setOpen] = useState(false);
  const fabRef = useRef(null);

  useEffect(() => {
    if (!open) return;
    const handleClick = (e) => {
      if (fabRef.current && !fabRef.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener("mousedown", handleClick);
    return () => document.removeEventListener("mousedown", handleClick);
  }, [open]);

  const handleSub = (mode) => {
    setOpen(false);
    onSelect(mode);
  };

  return (
    <div className={`smart-fab-container ${open ? "smart-fab-open" : ""}`} ref={fabRef}>
      {open && (
        <div className="smart-fab-menu">
          <button className="smart-fab-sub" onClick={() => handleSub("manual")} aria-label="Manual entry">
            <svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
              <line x1="16" y1="2" x2="16" y2="6" />
              <line x1="8" y1="2" x2="8" y2="6" />
              <line x1="3" y1="10" x2="21" y2="10" />
            </svg>
            <span className="smart-fab-sub-label">Manual</span>
          </button>
          <button className="smart-fab-sub" onClick={() => handleSub("chat")} aria-label="Chat">
            <svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
            </svg>
            <span className="smart-fab-sub-label">Chat</span>
          </button>
          <button className="smart-fab-sub" onClick={() => handleSub("school")} aria-label="School schedule">
            <svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M22 10v6" />
              <path d="M2 10l10-5 10 5-10 5z" />
              <path d="M6 12v5c3 3 9 3 12 0v-5" />
            </svg>
            <span className="smart-fab-sub-label">School</span>
          </button>
          <button className="smart-fab-sub" onClick={() => handleSub("camera")} aria-label="Camera">
            <svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z" />
              <circle cx="12" cy="13" r="4" />
            </svg>
            <span className="smart-fab-sub-label">Camera</span>
          </button>
          <button className="smart-fab-sub" onClick={() => handleSub("voice")} aria-label="Voice">
            <svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <rect x="9" y="1" width="6" height="12" rx="3" />
              <path d="M19 10v2a7 7 0 0 1-14 0v-2" />
              <line x1="12" y1="19" x2="12" y2="23" />
              <line x1="8" y1="23" x2="16" y2="23" />
            </svg>
            <span className="smart-fab-sub-label">Voice</span>
          </button>
        </div>
      )}
      <button
        className="smart-fab-main"
        onClick={() => setOpen((v) => !v)}
        aria-label={open ? "Close smart add" : "Smart add"}
      >
        <svg
          className="smart-fab-icon"
          viewBox="0 0 24 24"
          width="28"
          height="28"
          fill="none"
          stroke="currentColor"
          strokeWidth="2.5"
          strokeLinecap="round"
        >
          <line x1="12" y1="5" x2="12" y2="19" />
          <line x1="5" y1="12" x2="19" y2="12" />
        </svg>
      </button>
    </div>
  );
}
